(ns app.front.view.group.admin.pre-consultation-select
  (:require [app.domain.group.config.model :as config-model]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]))


(defn pre-consultation-selector [{:keys [ptc-id permit-type category-config tr selected-settings]}]
  (let [value            (:group.config/pre-consultation category-config)
        permission-value (:group.config/authority-creates-application? category-config)
        config-id        (:db/id category-config)
        effective-value  (or (get-in selected-settings [config-id :group.config/pre-consultation])
                             value
                             config-model/default-pre-consultation)
        effective-perm   (get-in selected-settings
                                 [config-id :group.config/authority-creates-application?]
                                 permission-value)
        on-change-fn     (fn [attr]
                           (fn [new-value]
                             (>evt [::gas/update-ptc-group-config-changes
                                    ptc-id
                                    config-id
                                    #(if (= new-value value)
                                       (dissoc % attr)
                                       (assoc % attr new-value))])))]
    [:div.mb-4 {:on-click #(.stopPropagation %)}
     [ui-select/select
      {:id           (str "pre-consultation-" permit-type config-id)
       :label-text   (tr [:group.config/pre-consultation])
       :required     true
       :values       config-model/pre-consultation-choice
       :val->str     (comp tr vector)
       :allow-empty? false
       :on-change    (on-change-fn :group.config/pre-consultation)
       :value        effective-value}]
     (when (= :group.config.pre-consultation/required effective-value)
       (cc/checkbox {:id         (str "pc-creator-" permit-type config-id)
                     :label-text (tr [:group.config/pre-consultation-permission])
                     :checked    (boolean effective-perm)
                     :on-change  (on-change-fn :group.config/authority-creates-application?)}))]))
